import {isAnyOf} from '@reduxjs/toolkit'

import {getResultInfo} from '@web/actions/result'
import {APIStatus, OrderPhase, ScheduledOrderEntry} from '@web/core/constants'
import {getSaleChannelType} from '@web/slices/common/slice'
import makeSlice from '@web/slices/common/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getResultInfo.fulfilled, (state, {payload: {order}}) => {
                if (order?.saleChannelType) {
                    state.entry = getSaleChannelType(order.saleChannelType)
                }

                if (order.scheduledChannelType === ScheduledOrderEntry.SUBSCRIPTION) {
                    state.entry = order.scheduledChannelType
                }

                state.orderPhase = OrderPhase.RESULT
                state.scene = APIStatus.RESOLVED
                state.seqID = order.orderNo
            })
            .addCase(getResultInfo.rejected, (state, {payload}) => {
                if (payload?.channel) {
                    state.entry = payload.channel
                }
            })
            .addMatcher(isAnyOf(getResultInfo.pending), (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addMatcher(isAnyOf(getResultInfo.fulfilled), (state) => {
                state.scene = APIStatus.RESOLVED
            })
            .addMatcher(isAnyOf(getResultInfo.rejected), (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default slice.reducer
